export default "__VITE_ASSET__CtlK5C8d__"